import cc from "classcat"
import { Transition } from "@headlessui/react"
import { RichText } from "prismic-reactjs"
import IconArrowDown from "images/icon-arrow-down.svg"
import { ChevronDownIcon } from "@heroicons/react/24/outline"

export default function Question({
  question,
  answer,
  active = false,
  onClick,
  theme = "dark",
}) {
  return (
    <div
      className={cc([
        "py-6",
        {
          "text-zinc-100 focus:text-zinc-200": theme === "light",
          "text-zinc-800 focus:text-zinc-700": theme === "dark",
        },
      ])}
    >
      <dt className="text-lg leading-7">
        <button
          type="button"
          className={cc([
            "flex w-full items-start justify-between text-left focus:outline-none",
            {
              "focus:text-white": theme === "light",
              "focus:text-zinc-600": theme === "dark",
            },
          ])}
          onClick={onClick}
        >
          <span className="font-bold">{question}</span>
          <span className="ml-6 flex h-7 items-center">
            <ChevronDownIcon
              className={cc([
                "h-6 w-6 transform transition duration-200 ease-in-out ",
                {
                  "rotate-180": active,
                  "rotate-0": !active,
                },
              ])}
            />
          </span>
        </button>
      </dt>
      <Transition
        show={active}
        enter="transition ease-out duration-100 transform"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75 transform"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <dd className="prismic-rich-text mt-2 pr-12 text-base">
          <RichText render={answer} />
        </dd>
      </Transition>
    </div>
  )
}
